// extracted by mini-css-extract-plugin
module.exports = {"header":"InstructorApproverHeader_header__24LO7","breadcrumb":"InstructorApproverHeader_breadcrumb__2z0WE","back":"InstructorApproverHeader_back__2Tbpv"};